import { useTranslation } from "react-i18next";

/**
 * Passwort-Kriterien mit Live-Checkboxen.
 * Muss synchron zu backend/src/utils/password.util.js gehalten werden.
 */
export const passwordRules = [
  { key: "minLength", test: (pw) => typeof pw === "string" && pw.length >= 8 },
  { key: "upper", test: (pw) => /[A-Z]/.test(pw || "") },
  { key: "lower", test: (pw) => /[a-z]/.test(pw || "") },
  { key: "digit", test: (pw) => /[0-9]/.test(pw || "") },
];

export function isStrongPassword(password) {
  return passwordRules.every((rule) => rule.test(password));
}

export default function PasswordCriteria({ password }) {
  const { t } = useTranslation();

  return (
    <ul className="password-criteria" aria-label={t("auth.passwordCriteria.title")}>
      {passwordRules.map((rule) => {
        const met = rule.test(password);
        return (
          <li
            key={rule.key}
            className={`password-criteria__item ${
              met ? "password-criteria__item--met" : ""
            }`}
          >
            <span className="password-criteria__icon" aria-hidden="true">
              {met ? "✓" : "○"}
            </span>
            <span className="password-criteria__label">
              {t(`auth.passwordCriteria.${rule.key}`)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
